// extracted by mini-css-extract-plugin
export default {"title":"EditListingServicesPanel_title__oo6ki"};